function initShareButton(button, options = {}) {
  if (!button) {
    return;
  }

  const shareIcon = button.querySelector('.share-icon');
  const successIcon = button.querySelector('.share-icon-success');
  const originalIconClass = shareIcon?.className || 'fa-solid fa-share-alt share-icon';

  button.addEventListener('click', async function(event) {
    event.preventDefault();

    const url = options.url || window.location.href;
 
     function isMobileDevice() {
       return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
     }
 
    if (navigator.share && isMobileDevice()) {
      try {
        await navigator.share({
          title: document.title,
          url: url
         });
       } catch (err) {
         console.log('Teilen abgebrochen oder Fehler:', err);
       }
     } else {
      const copyToClipboard = async () => {
        try {
          await navigator.clipboard.writeText(url);
          return true;
        } catch (err) {
          // Fallback für Browser ohne Clipboard API
          try {
            const tempInput = document.createElement('textarea');
            tempInput.value = url;
            tempInput.setAttribute('readonly', '');
            tempInput.style.position = 'absolute';
            tempInput.style.left = '-9999px';
            document.body.appendChild(tempInput);
            tempInput.select();
            const success = document.execCommand('copy');
            document.body.removeChild(tempInput);
            return success;
          } catch (fallbackErr) {
            console.error('Clipboard fallback failed:', fallbackErr);
            return false;
          }
        }
      };

      const success = await copyToClipboard();

      if (!success) {
        alert('Fehler beim Kopieren der URL.');
        return;
      }

      // Icon umschalten
      button.classList.add('btn-success', 'share-shake', 'is-copied');

      // Shake-Animation nach 0.5s entfernen
      setTimeout(() => {
        button.classList.remove('share-shake');
      }, 500); // Dauer exakt wie Animation

      // Nach 3 Sekunden alles zurücksetzen
      setTimeout(() => {
        button.classList.remove('btn-success', 'is-copied');
        if (shareIcon) {
          shareIcon.className = originalIconClass;
        }
        if (successIcon) {
          successIcon.className = 'fa-solid fa-check share-icon-success';
        }
      }, 3000);
    }
  });
}
 
 // Auto-Init für alle Buttons mit data-share-button
 document.addEventListener('DOMContentLoaded', function() {
   const shareButtons = document.querySelectorAll('[data-share-button]');
   shareButtons.forEach(button => {
     const url = button.getAttribute('data-share-url');
     initShareButton(button, { url: url });
   });
 });
 
